var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-toggle d-block d-lg-none mr-1",on:{"click":_vm.toggle}},[_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"icon":"MenuIcon","size":"21"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }